// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gE25","colBig":"styles_colBig__rOh9t","colSmall":"styles_colSmall__A_r5V"};